import { render, staticRenderFns } from "./StickerSetupSource.vue?vue&type=template&id=0059da8f&scoped=true"
import script from "./StickerSetupSource.vue?vue&type=script&lang=ts"
export * from "./StickerSetupSource.vue?vue&type=script&lang=ts"
import style0 from "./StickerSetupSource.vue?vue&type=style&index=0&id=0059da8f&prod&lang=scss"
import style1 from "./StickerSetupSource.vue?vue&type=style&index=1&id=0059da8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0059da8f",
  null
  
)

export default component.exports